import { Box, alpha, useTheme } from '@mui/material';
import { AnimationControls, TargetAndTransition, VariantLabels, m } from 'framer-motion';

export default function PulsingDot({ handleClickHintDot }: { handleClickHintDot: () => void }) {
  const theme = useTheme();
  const animation: AnimationControls | TargetAndTransition | VariantLabels | boolean = {
    boxShadow: [
      `0 0 0 0 ${alpha(theme?.palette?.primary?.main, 0.7)}`,
      `0 0 0 1rem ${alpha(theme?.palette?.primary?.main, 0)}`,
      `0 0 0 0 ${alpha(theme?.palette?.primary?.main, 0)}`,
    ],
    scale: [0.95, 1, 0.95],
  };

  return (
    <Box
      onClick={() => handleClickHintDot()}
      component={m.div}
      sx={{ width: '1rem', height: '1rem', borderRadius: '50%', backgroundColor: 'primary.main' }}
      animate={animation}
      transition={{ duration: 3, repeat: Infinity }}
    />
  );
}
